"use client"

import { useToggleRefinement } from "react-instantsearch"

import { priceAttribute } from "@lib/search-client"

/**
 * Narrows to products whose calculated price is below their original in the
 * region's currency. Hides itself when nothing is discounted, which is the
 * case until a price list applies to some product.
 */
const OnSaleToggle = ({ currencyCode }: { currencyCode: string }) => {
  const { value, refine, canRefine } = useToggleRefinement({
    attribute: priceAttribute("on_sale", currencyCode),
    on: true,
  })

  if (!canRefine) {
    return null
  }

  return (
    <label className="flex cursor-pointer items-center gap-x-2">
      <input
        type="checkbox"
        checked={value.isRefined}
        onChange={() => refine(value)}
        className="shrink-0 zl-checkbox mt-0.5"
        data-testid="on-sale-toggle"
      />
      <span className="zl-badge text-zl-steel">
        Solo ofertas
      </span>
      {typeof value.count === "number" && (
        <span className="text-small-regular text-ui-fg-muted">
          ({value.count})
        </span>
      )}
    </label>
  )
}

export default OnSaleToggle
